import {historyInfoActionTypes} from "../_constants";

export const historyInfoActions = {
    push,
	pop,
};

/**
 * Redux Action method that add the given location
 *
 * @param location the new location
 * @returns {{type: string, message: *}}
 */
function push(location) {
	return { type: historyInfoActionTypes.PUSH, location };
}

/**
 * Redux Action method that removes the last location
 *
 * @param location the new location
 * @returns {{type: string, message: *}}
 */
function pop(location) {
	return { type: historyInfoActionTypes.POP, location };
}